import { store } from '@csrc/redux/storeConfig/store'
import { TemplateItems } from "@cmodules/checklist/utility/TemplateItemsConst"
import { _getParentPage } from "@cmodules/checklist/utility/template-builder-utilities"
import { generatePreviewData } from "@cmodules/checklist/utility/templateBuilderContext-new"
import { getBackendUrl, _getGlobal } from '@utils'
import { structureDataForPreview } from '@csrc/modules/checklist/utility/template-builder-utilities'
import { _logWithFileContext } from './Utils'
import { TemplatePreview } from '@csrc/modules/checklist/assets/data/types'

//************************************//
const getTemplatePreviewData = (data = null) => {
  if (data) {
    const template = _.cloneDeep(data)
    return {
      ...template.present,
      global_items: template.nested_templates || []
    }
  } else {
    const template = _.cloneDeep(store.getState().checklist.template)
    return {
      ...template.present,
      global_items: template.nested_templates || []
    }
  }
}
//************************************//
export const SendMessageToFlutterApp = (type, data) => {
  // console.log(type, data)
  try {
    document
      .getElementById('preview_mobile_app')
      .contentWindow
      .postMessage({
        type,
        data
      })
  } catch (e) {
    // console.error('FlutterWebMiddleware', 'SendMessageToFlutterApp', e)
  }
}
//************************************//
export const SendInitPreviewToFlutterApp = (data = null) => {
  const template = getTemplatePreviewData(data)
  // _logWithFileContext({ template })

  if (template) {
    const selected_item = store.getState().checklist.ui.currentItem
    let selected_item_id = null
    let selected_item_page_id = null
    if (!_.isEmpty(selected_item)) {
      selected_item_id = selected_item.id
    } else {
      const pages = _.filter(template.items, x => x.type === 'page')
      if (_.size(pages) === 1) {
        selected_item_page_id = _.get(pages, '0.id')
      }
    }
    // Structure data for preview:
    // - Only top-level items are processed here
    // - Nested global_items are already structured at their creation time from calling layer (no need to re-process)
    const structuredData = structureDataForPreview({
      ...data,
      ...template
    })
    // _logWithFileContext({ structuredData })
    const finalData = TemplatePreview.fromProcessingPreviewData(structuredData)
    _logWithFileContext({ structuredData, finalData })
    // const jsonFile = require('../assets/version-data.json')
    // _logWithFileContext({ jsonFile })

    SendMessageToFlutterApp(
      "init_preview",
      {
        template: finalData,
        selected_item: {
          item_id: selected_item_id,
          page_id: selected_item_page_id
        }
      }
    )
  } else {
    setTimeout(() => {
      SendInitPreviewToFlutterApp(data)
    }, 1000)
  }
}
//************************************//
export const SendInitAppToFlutterApp = ({ lang = _getGlobal('APP_LANG'), mode = "" }) => {
  const settings = store.getState().app.settings
  const user = store.getState().user
  const url = getBackendUrl()
  SendMessageToFlutterApp(
    'init_app',
    {
      settings,
      user: {
        ...user.userData,
        token: user.token
      },
      lang,
      mode,
      backend_url: url.endsWith('/') ? url : `${url}/`
    }
  )
}
//************************************//
const recieveMessageListener = (event, callbackFunctions = {}) => {
  // Check the origin of the message
  // if (event.origin !== '') {
  //     return
  // }
  // Handle the message
  const data = event.data
  _logWithFileContext({ data })
  switch (data.type) {
    case 'app_ready':
      if (callbackFunctions?.app_ready?.before) {
        callbackFunctions?.app_ready?.before()
      }
      if (callbackFunctions?.app_ready?.mainProgram) {
        callbackFunctions?.app_ready?.mainProgram()
      }
      if (callbackFunctions?.app_ready?.after) {
        callbackFunctions?.app_ready?.after()
      }
      break
    default:
      break
  }
}
let currentListener = null
//************************************//
export const ReceiveMessagesFromFlutterAppListener = (callbackFunctions) => {
  currentListener = (e) => recieveMessageListener(e, callbackFunctions)
  window.addEventListener('message', currentListener, true)
}
//************************************//
export const RemoveReceivingMessagesFromFlutterAppListener = () => {
  if (currentListener) {
    window.removeEventListener('message', currentListener, true)
    currentListener = null
  }
}
//************************************//
export const SendSelectItemToFlutterApp = (item) => {
  let parent_page = null
  let item_id = null
  if (item?.type && TemplateItems[item.type].type === 'page') {
    parent_page = item
  } else {
    item_id = item.id
    parent_page = _getParentPage(item)
  }
  SendMessageToFlutterApp(
    "select_item",
    {
      selected_item: {
        item_id,
        page_id: parent_page.id
      }
    }
  )
}
//************************************//
export const SendDropItemToFlutterApp = (data) => {
  const template = getTemplatePreviewData()
  const currentItemFromStore = store.getState().checklist?.ui?.currentItem
  const currentItem = _.find(data, x => x?.id === currentItemFromStore?.id)
  const parent_page = _getParentPage(currentItem)
  SendMessageToFlutterApp(
    'drop_item',
    {
      template: {
        ...template,
        items: generatePreviewData()
      },
      selected_item: {
        item_id: currentItem?.id,
        page_id: parent_page?.id
      }
    }
  )
}
//************************************//
export const SendInitPdfToFlutterApp = (inspection) => {
  _logWithFileContext({ inspection })

  SendMessageToFlutterApp(
    'init_pdf',
    {
      inspection
    }
  )
}
